<template lang='pug'>
  include ./../../mixins
  div
    validation-observer(
      tag="form"
      ref="observer"
      v-slot="props"
      @submit.prevent="validateBeforeSubmit"
    )

      validation-provider.position_relative(
        tag="div"
        v-slot="{errors}"
        rules="required"
        name="id"
      )
        +b.form--input.--placeholder_center.margin_bottom_lg.INPUT(
          :placeholder="_('ID')"
          type='text'
          name='id'
          @keyup.enter="validateBeforeSubmit"
          required
          v-model="formdata.id_user"
        )

        +b.error-text--login.SPAN {{ errors[0] }}

      validation-provider.position_relative(
        tag="div"
        v-slot="{errors}"
        rules="required"
        name="password"
      )
        +b.form--input.--placeholder_center.margin_bottom_lg.INPUT(
          :placeholder="_('Password')"
          type='password'
          name='password'
          @keyup.enter="validateBeforeSubmit"
          required
          v-model="formdata.password"
        )

        +b.error-text--login.SPAN {{ errors[0] }}
    
    +b.button--color_blue.--width_full.fs_md.BUTTON(
      @click.prevent="validateBeforeSubmit"
      :disabled='clicked'
      type='submit'
    ) {{_('Login')}}
    +b.position_relative.margin_top_lg(v-if='errorText.length > 0')
      +b.error-text--login.SPAN {{ errorText }}


</template>

<script>
import FormMixin, { defaultValidatorErrorsParser } from './../../mixins/form-mixin'
import { loginResource } from '@services/auth'
export default {
  mixins: [ FormMixin ],
  data() {
    return {
      clicked: false,
      errorText: '',
      formdata: {
        id_user: '',
        password: '',
      }
    }
  },

  methods: {
    send(data) {
      return loginResource.execute({}, data)
        .then((res) => {       
          window.location.replace(res.redirect)
          this.$refs.observer.reset()
        })
    },

    async validateBeforeSubmit() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.submit(isValid)
      } else {
        return
      }
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(parsed)
      this.errorText = parsed.non_field_errors[0]
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/LoginForm.vue